import {ApiFileUploadRequest} from "../../api/api-file-upload-request";
import {FlexTrade} from "./flex-trade";

export class FlexTradesRequest extends ApiFileUploadRequest {

  ownerCode: string = "";
  trades: FlexTrade[] = [];
  mapping: string = "";

}
